import { render } from "./AntojitosView.vue?vue&type=template&id=12478c8c&scoped=true"
import script from "./AntojitosView.vue?vue&type=script&lang=js"
export * from "./AntojitosView.vue?vue&type=script&lang=js"

import "./AntojitosView.vue?vue&type=style&index=0&id=12478c8c&scoped=true&lang=css"
import "./AntojitosView.vue?vue&type=style&index=1&id=12478c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12478c8c"]])

export default __exports__